import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import assign from 'object-assign';

import AutoComplete from '../Common/AutoComplete';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import OrganisationCategoriesTable from './OrganisationCategoriesTable';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import ListIcon from 'material-ui/svg-icons/action/list';
import CategoryActions from '../../actions/CategoryActionCreator';
import OrganisationActions from '../../actions/OrganisationActionCreator';
import CategoryStore from '../../stores/CategoryStore';
import OrganisationStore from '../../stores/OrganisationStore';
import OrganisationCategoryStore from '../../stores/OrganisationCategoryStore';

import buildContextMenu from '../Common/BuildContextMenu';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};

class OrganisationSettings extends Component {

    componentDidMount() {
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onOrganisationChange = this.onOrganisationChange.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.addCategory = this.addCategory.bind(this);
        this.removeCategory = this.removeCategory.bind(this);

        this.categoryListener = CategoryStore.addListener(this.onCategoryChange);
        CategoryActions.getRoots();

        this.organisationListener = OrganisationStore.addListener(this.onOrganisationChange);
        OrganisationActions.getById(this.state.organisationId);
    }

    componentWillUnmount() {
        this.categoryListener.remove();
        this.organisationListener.remove();
    }

    render() {
        const isRoot = this.context.auth.isRoot();
        const dialogActions = [
            <FlatButton label="Cancel" onTouchTap={this.closeDialog} />,
            <FlatButton label="Add" onTouchTap={this.addCategory} disabled={this.state.dialog.value === null} />,
        ];

        return (
            <DetailView
                title = {this.state.title}
                backButton={true}
                actions = {buildContextMenu(this.getActions())}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title='Categories'
                            subtitle='manage categories visible to this organisation'
                            avatar={<ListIcon {...iconProps}/>}
                        />
                        <OrganisationCategoriesTable organisationId={this.state.organisationId} />
                       {isRoot && (
                           <CardActions>
                                <FlatButton key="addCategory" label="Add" onTouchTap={this.openDialog.bind(this)} />
                            </CardActions>
                       )}
                    </Card>
                </div>
                {isRoot && (
                    <Dialog
                        title="Add Category"
                        open={this.state.dialog.open}
                        modal={false}
                        actions={dialogActions}
                    >
                        <AutoComplete
                            floatingLabelText="Name"
                            maxSearchResults={5}
                            dataSource={this.state.dataSource}
                        />
                    </Dialog>
                )}
            </DetailView>
        );
    }

    getActions() {
        return [

            {
                link: `/dashboard/organisation/${this.state.organisationId}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                type: 'divider'
            },
            {
                link: `/dashboard/organisation/${this.state.organisationId}/edit`,
                icon: <EditIcon />,
                label: 'Edit',
            },
        ];
    }

    onCategoryChange() {
        const rootCategories = CategoryStore.getRoots();
        if (rootCategories !== undefined) {
            const dataSource = rootCategories.map((category) => {
                const click = this.onSelectCategory.bind(this, category);
                return {
                    id: category.id,
                    name: category.name,
                    text: category.name,
                    value: <MenuItem key={category.id} value={category.id} primaryText={category.name} onTouchTap={click}/>
                };
            }, this);
            this.setState({dataSource});
        }
    }

    onOrganisationChange() {
        const organisation = OrganisationStore.getById(this.state.organisationId);
        if (organisation !== undefined) {
            this.setState({title: organisation.name});
        }
    }

    onSelectCategory(category) {
        this.setState({dialog: assign({}, this.state.dialog, {value: category.id})});
    }

    openDialog() {
        this.setState({dialog: assign({}, this.state.dialog, {open: true})});
    }

    closeDialog() {
        this.setState({dialog: assign({}, this.state.dialog, {open: false, value: null})});
    }

    addCategory() {
        CategoryActions.addOrganisation(this.state.dialog.value, this.state.organisationId);
        this.closeDialog();
    }

    removeCategory(id) {
        CategoryActions.removeOrganisation(id, this.state.organisationId);
    }
}

OrganisationSettings.getStores = () => ([OrganisationCategoryStore]);
OrganisationSettings.calculateState = (prevState, {routeParams}) => {
    const organisationId = (prevState && prevState.organisationId || Number(routeParams.id));
    return ({
        organisationId,
        title: (!!prevState && prevState.title) || '',
        dataSource: (!!prevState && prevState.dataSource) || [],
        dialog: {
            open: false,
            value: null
        }
    });
};

OrganisationSettings.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Container.create(OrganisationSettings, {withProps: true});
